module.exports = __webpack_public_path__ + "img/violet_099.677eaac9.png";